<template>
    <section class="category-grid">

        <template v-if="category">
            <router-link v-for="sub in category.subcategories" :key="sub.name" class="category-card" :to="{ name: 'subcategory', params: { categorySlug: category.slug, subcategorySlug: sub.slug }}">
                <div class="background-transition"></div>
                <span>{{ sub.name }}</span>
            </router-link>
        </template>
        <template v-else>
            <router-link v-for="cat in categories" :key="cat.name" class="category-card" :to="{ name: 'category', params: { categorySlug: cat.slug }}">
                <div class="background-transition"></div>
                <span>{{ cat.name }}</span>
            </router-link>
        </template>

    </section>
</template>

<script>
    export default {
        props: {
            categories: Array,
            category: Object,
        },
    }
</script>

<style lang="scss" scoped>

    @import '@/scss/common.scss';

    .category-grid {

        margin: -7.5px;
        display: flex;
        flex-flow: row wrap;

        .category-card {
            @extend %falesca-h-16;
            @include transition(background-image 0.5s ease);

            display: block;
            position: relative;

            @include responsive-width(169px, 146px, 172px, 169px);
            @include responsive-margin(7.5px, 5px, 7.5px, 7.5px);
            @include responsive-padding(15px, 10px, 15px, 15px);
            @include responsive-font-size(16px, 14px, 16px, 16px);

            height: 60px;

            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center !important;

            background-color: $primary;
            background-image: url(/static/img/ui/button-category-hover.png);
            color: white;
            letter-spacing: 1pt;

            .background-transition {
                @include transition(opacity 0.25s ease);
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                background-image: url(/static/img/ui/button-category.png);
            }

            span {
                z-index: 2;
            }

            &:hover {
                // @include transition(background-image 0.5s ease);
                // background-image: url(/static/img/ui/button-category-hover.png);
                color: $primary;
                .background-transition {
                    @include transition(opacity 0.25s ease);
                    opacity: 0.0;
                }
            }
        }
    }


</style>